/**
 * @param {string} url
 * @returns {string | undefined}
 */
export function getSubdomainFromUrl(url) {
  const firstSegment = new URL(url).hostname.split(".")[0]

  // bare domain, e.g. churchcenter.com, www.churchcenter.com, or staging.churchcenter.com
  if (["churchcenter", "www", "staging"].includes(firstSegment))
    return undefined

  // remove branch if present
  return firstSegment.split("--")[0]
}
